import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "../locales/en/translation.json";
import nlTranslation from "../locales/nl/translation.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  nl: {
    translation: nlTranslation,
  },
};

const isDevelopment = process.env.NODE_ENV === 'development';

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "nl",
    defaultNS: "translation",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    saveMissing: isDevelopment,
    missingKeyHandler: isDevelopment
      ? (lngs, ns, key, fallbackValue) => {
          console.warn(`Missing translation: ${key} in languages: ${lngs.join(', ')}`);
        }
      : undefined,
    react: {
      useSuspense: false,
    },
  });

export default i18n;
